import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 14l6 6h-6l0 -6","key":"svg-0"}],["path",{"d":"M20 10l-6 -6h6l0 6","key":"svg-1"}],["path",{"d":"M4 4v4l12 12h4v-4l-12 -12l-4 0","key":"svg-2"}]]

const IconBrandAppleNews = createReactComponent('outline', 'brand-apple-news', 'BrandAppleNews', __iconNode);

export default IconBrandAppleNews;